import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingSceneId } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingSceneReplayed.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { AgentOnboardingSceneId } from './agentOnboardingAnalytics';

export type UseTrackAgentOnboardingSceneReplayedParams = {
  scene_id: AgentOnboardingSceneId;
};

export const useTrackAgentOnboardingSceneReplayed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingSceneReplayed = useCallback(
    (params: UseTrackAgentOnboardingSceneReplayedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingSceneReplayed };
};
